const translations = {
  en: {
    // Landing
    landing_tagline: "Where Balkan hearts find each other",
    select_heritage: "Select Your Heritage",
    continue: "Continue",
    already_have_account: "Already have an account? Log in",
    
    // Countries
    country_slovenia: "Slovenia",
    country_croatia: "Croatia",
    country_bosnia: "Bosnia & Herzegovina",
    country_serbia: "Serbia",
    country_montenegro: "Montenegro",
    country_north_macedonia: "North Macedonia",
    country_kosovo: "Kosovo",
    selected_heritage: "Selected Heritage",
    
    // Onboarding
    i_am_a: "I am a...",
    looking_for: "Looking for...",
    age_range: "Age Range",
    man: "Man",
    woman: "Woman",
    years_old: "years old",
    back: "Back",
    next: "Next",
    get_started: "Get Started",
    
    // Auth
    enter_email: "Enter your email",
    verify_email: "Verify your email",
    complete_profile: "Complete your profile",
    send_code: "We'll send you a verification code",
    enter_code: "Enter the 6-digit code sent to",
    tell_us: "Tell us about yourself",
    continue_google: "Continue with Google",
    or_use_email: "or use email",
    email_address: "Email Address",
    verification_code: "Verification Code",
    send_verification: "Send Verification Code",
    verify_continue: "Verify & Continue",
    different_email: "Use a different email",
    first_name: "First Name",
    last_name: "Last Name",
    date_of_birth: "Date of Birth",
    current_city: "Current City",
    about_you: "About You",
    join_yublink: "Join YuBlink",
    creating_account: "Creating Account...",
    sending: "Sending...",
    verifying: "Verifying...",
    
    // Browse
    discover: "Discover",
    active_now: "Active Now",
    origin_country: "Origin Country",
    all_countries: "All Countries",
    city: "City",
    search_city: "Search by city...",
    verified_only: "Verified Only",
    show_verified: "Showing verified",
    show_all: "Show all",
    no_users: "No users found",
    adjust_filters: "Try adjusting your filters",
    blink: "Blink",
    chat: "Chat",
    
    // Profile
    about: "About",
    heritage: "Heritage",
    lives_in: "Lives in",
    photos: "Photos",
    message: "Message",
    report: "Report",
    block: "Block",
    edit_profile: "Edit Profile",
    report_user: "Report User",
    reason: "Reason",
    submit_report: "Submit Report",
    
    // Chat
    messages: "Messages",
    no_conversations: "No conversations yet",
    start_chatting: "Start chatting from the Browse page",
    select_conversation: "Select a conversation",
    type_message: "Type a message...",
    back_to_messages: "Back to messages",
    
    // Settings
    settings: "Settings",
    profile_visibility: "Profile Visibility",
    visible_to_others: "Your profile is visible to others",
    profile_hidden: "Your profile is hidden",
    message_filter: "Message Filter",
    choose_who: "Choose who can send you messages",
    all_users: "All Users",
    verified_users_only: "Verified Users Only",
    premium_status: "Premium Status",
    active_premium: "Active Premium Member",
    free_plan: "Free plan - 10 chats/day",
    upgrade: "Upgrade",
    save_settings: "Save Settings",
    saving: "Saving...",
    delete_account: "Delete Account",
    delete_permanently: "Permanently delete your account and all data",
    delete_my_account: "Delete My Account",
    
    // Premium
    premium: "Premium",
    yublink_premium: "YuBlink Premium",
    unlimited_chats: "Unlimited Chats",
    no_daily_limits: "No daily limits on new conversations",
    verified_badge: "Verified Badge",
    stand_out: "Stand out with a trusted verified profile",
    priority_search: "Priority in Search",
    appear_first: "Appear first in browse results",
    premium_member: "Premium Member",
    exclusive_access: "Exclusive access to premium features",
    upgrade_now: "Upgrade Now",
    per_month: "/month",
    welcome_premium: "Welcome to Premium!",
    account_upgraded: "Your account has been upgraded successfully.",
    verifying_payment: "Verifying your payment...",
    youre_premium: "You're Premium!",
    enjoy_features: "Enjoy all premium features including unlimited chats and verified badge.",
    
    // Admin
    admin_dashboard: "Admin Dashboard",
    overview: "Overview",
    users: "Users",
    reports: "Reports",
    total_users: "Total Users",
    premium_users: "Premium Users",
    total_chats: "Total Chats",
    total_messages: "Total Messages",
    feedback: "Feedback",
    search_users: "Search by name or email...",
    
    // Footer
    support: "Support",
    
    // Feedback
    support_feedback: "Support & Feedback",
    report_bugs: "Report bugs or suggest improvements",
    bug_report: "Bug Report",
    suggestion: "Suggestion",
    email_optional: "Email (optional)",
    describe_issue: "Describe the issue or your suggestion...",
    submit_feedback: "Submit Feedback",
    thank_you: "Thank you!",
    feedback_submitted: "Your feedback has been submitted successfully.",
    go_back: "Go Back",
    
    // Legal
    impressum: "Impressum",
    datenschutz: "Datenschutz (GDPR)",
    agb: "AGB",
    
    // Common
    logout: "Logout",
    loading: "Loading...",
    browse: "Browse",
    profile: "Profile",
  },
  
  hr: {
    landing_tagline: "Gdje se balkanska srca pronalaze",
    select_heritage: "Odaberi Svoje Porijeklo",
    continue: "Nastavi",
    already_have_account: "Već imaš račun? Prijavi se",
    country_slovenia: "Slovenija",
    country_croatia: "Hrvatska",
    country_bosnia: "Bosna i Hercegovina",
    country_serbia: "Srbija",
    country_montenegro: "Crna Gora",
    country_north_macedonia: "Sjeverna Makedonija",
    country_kosovo: "Kosovo",
    selected_heritage: "Odabrano Porijeklo",
    i_am_a: "Ja sam...",
    looking_for: "Tražim...",
    age_range: "Dobni Raspon",
    man: "Muškarac",
    woman: "Žena",
    years_old: "godina",
    back: "Natrag",
    next: "Dalje",
    get_started: "Započni",
    enter_email: "Unesi svoj email",
    verify_email: "Potvrdi svoj email",
    complete_profile: "Dovrši svoj profil",
    send_code: "Poslat ćemo ti verifikacijski kod",
    enter_code: "Unesi 6-znamenkasti kod poslan na",
    tell_us: "Reci nam nešto o sebi",
    continue_google: "Nastavi s Googleom",
    or_use_email: "ili koristi email",
    email_address: "Email Adresa",
    verification_code: "Verifikacijski Kod",
    send_verification: "Pošalji Verifikacijski Kod",
    verify_continue: "Potvrdi i Nastavi",
    different_email: "Koristi drugi email",
    first_name: "Ime",
    last_name: "Prezime",
    date_of_birth: "Datum Rođenja",
    current_city: "Trenutni Grad",
    about_you: "O Tebi",
    join_yublink: "Pridruži se YuBlinku",
    creating_account: "Kreiranje računa...",
    sending: "Slanje...",
    verifying: "Provjera...",
    discover: "Otkrij",
    active_now: "Aktivni Sada",
    origin_country: "Zemlja Porijekla",
    all_countries: "Sve Zemlje",
    city: "Grad",
    search_city: "Pretraži po gradu...",
    verified_only: "Samo Verificirani",
    show_verified: "Prikaz verificiranih",
    show_all: "Prikaži sve",
    no_users: "Nema pronađenih korisnika",
    adjust_filters: "Pokušaj prilagoditi filtere",
    blink: "Blink",
    chat: "Chat",
    about: "O Meni",
    heritage: "Porijeklo",
    lives_in: "Živi u",
    photos: "Fotografije",
    message: "Poruka",
    report: "Prijavi",
    block: "Blokiraj",
    edit_profile: "Uredi Profil",
    report_user: "Prijavi Korisnika",
    reason: "Razlog",
    submit_report: "Pošalji Prijavu",
    messages: "Poruke",
    no_conversations: "Još nema razgovora",
    start_chatting: "Započni razgovor sa stranice Pregledaj",
    select_conversation: "Odaberi razgovor",
    type_message: "Napiši poruku...",
    back_to_messages: "Natrag na poruke",
    settings: "Postavke",
    profile_visibility: "Vidljivost Profila",
    visible_to_others: "Tvoj profil je vidljiv drugima",
    profile_hidden: "Tvoj profil je skriven",
    message_filter: "Filter Poruka",
    choose_who: "Odaberi tko ti može slati poruke",
    all_users: "Svi Korisnici",
    verified_users_only: "Samo Verificirani Korisnici",
    premium_status: "Premium Status",
    active_premium: "Aktivni Premium Član",
    free_plan: "Besplatni plan - 10 chatova/dan",
    upgrade: "Nadogradi",
    save_settings: "Spremi Postavke",
    saving: "Spremanje...",
    delete_account: "Izbriši Račun",
    delete_permanently: "Trajno izbriši svoj račun i sve podatke",
    delete_my_account: "Izbriši Moj Račun",
    premium: "Premium",
    yublink_premium: "YuBlink Premium",
    unlimited_chats: "Neograničeni Chatovi",
    no_daily_limits: "Bez dnevnih ograničenja na nove razgovore",
    verified_badge: "Verificirana Značka",
    stand_out: "Istakni se s pouzdanim verificiranim profilom",
    priority_search: "Prioritet u Pretrazi",
    appear_first: "Pojavi se prvi u rezultatima pregledavanja",
    premium_member: "Premium Član",
    exclusive_access: "Ekskluzivni pristup premium značajkama",
    upgrade_now: "Nadogradi Sada",
    per_month: "/mjesečno",
    welcome_premium: "Dobrodošao u Premium!",
    account_upgraded: "Tvoj račun je uspješno nadograđen.",
    verifying_payment: "Provjera tvoje uplate...",
    youre_premium: "Ti si Premium!",
    enjoy_features: "Uživaj u svim premium značajkama uključujući neograničene chatove i verificiranu značku.",
    admin_dashboard: "Administratorska Ploča",
    overview: "Pregled",
    users: "Korisnici",
    reports: "Prijave",
    total_users: "Ukupno Korisnika",
    premium_users: "Premium Korisnika",
    total_chats: "Ukupno Chatova",
    total_messages: "Ukupno Poruka",
    feedback: "Povratne Informacije",
    search_users: "Pretraži po imenu ili emailu...",
    support: "Podrška",
    support_feedback: "Podrška i Povratne Informacije",
    report_bugs: "Prijavi greške ili predloži poboljšanja",
    bug_report: "Prijava Greške",
    suggestion: "Prijedlog",
    email_optional: "Email (neobavezno)",
    describe_issue: "Opiši problem ili svoj prijedlog...",
    submit_feedback: "Pošalji",
    thank_you: "Hvala!",
    feedback_submitted: "Tvoje povratne informacije su uspješno poslane.",
    go_back: "Natrag",
    impressum: "Impressum",
    datenschutz: "Zaštita Podataka (GDPR)",
    agb: "Uvjeti Korištenja",
    logout: "Odjava",
    loading: "Učitavanje...",
    browse: "Pregledaj",
    profile: "Profil",
  },
  
  bs: {
    landing_tagline: "Gdje se balkanska srca pronalaze",
    select_heritage: "Odaberi Svoje Porijeklo",
    continue: "Nastavi",
    already_have_account: "Već imaš račun? Prijavi se",
    country_slovenia: "Slovenija",
    country_croatia: "Hrvatska",
    country_bosnia: "Bosna i Hercegovina",
    country_serbia: "Srbija",
    country_montenegro: "Crna Gora",
    country_north_macedonia: "Sjeverna Makedonija",
    country_kosovo: "Kosovo",
    selected_heritage: "Odabrano Porijeklo",
    i_am_a: "Ja sam...",
    looking_for: "Tražim...",
    age_range: "Dobni Raspon",
    man: "Muškarac",
    woman: "Žena",
    years_old: "godina",
    back: "Nazad",
    next: "Dalje",
    get_started: "Započni",
    enter_email: "Unesi svoj email",
    verify_email: "Potvrdi svoj email",
    complete_profile: "Dovrši svoj profil",
    send_code: "Poslaćemo ti verifikacijski kod",
    enter_code: "Unesi 6-cifreni kod poslan na",
    tell_us: "Reci nam nešto o sebi",
    continue_google: "Nastavi s Googleom",
    or_use_email: "ili koristi email",
    email_address: "Email Adresa",
    verification_code: "Verifikacijski Kod",
    send_verification: "Pošalji Verifikacijski Kod",
    verify_continue: "Potvrdi i Nastavi",
    different_email: "Koristi drugi email",
    first_name: "Ime",
    last_name: "Prezime",
    date_of_birth: "Datum Rođenja",
    current_city: "Trenutni Grad",
    about_you: "O Tebi",
    join_yublink: "Pridruži se YuBlinku",
    creating_account: "Kreiranje računa...",
    sending: "Slanje...",
    verifying: "Provjera...",
    discover: "Otkrij",
    active_now: "Aktivni Sada",
    origin_country: "Zemlja Porijekla",
    all_countries: "Sve Zemlje",
    city: "Grad",
    search_city: "Pretraži po gradu...",
    verified_only: "Samo Verificirani",
    show_verified: "Prikaz verificiranih",
    show_all: "Prikaži sve",
    no_users: "Nema pronađenih korisnika",
    adjust_filters: "Pokušaj prilagoditi filtere",
    blink: "Blink",
    chat: "Chat",
    about: "O Meni",
    heritage: "Porijeklo",
    lives_in: "Živi u",
    photos: "Fotografije",
    message: "Poruka",
    report: "Prijavi",
    block: "Blokiraj",
    edit_profile: "Uredi Profil",
    report_user: "Prijavi Korisnika",
    reason: "Razlog",
    submit_report: "Pošalji Prijavu",
    messages: "Poruke",
    no_conversations: "Još nema razgovora",
    start_chatting: "Započni razgovor sa stranice Pregledaj",
    select_conversation: "Odaberi razgovor",
    type_message: "Napiši poruku...",
    back_to_messages: "Nazad na poruke",
    settings: "Postavke",
    profile_visibility: "Vidljivost Profila",
    visible_to_others: "Tvoj profil je vidljiv drugima",
    profile_hidden: "Tvoj profil je sakriven",
    message_filter: "Filter Poruka",
    choose_who: "Odaberi ko ti može slati poruke",
    all_users: "Svi Korisnici",
    verified_users_only: "Samo Verificirani Korisnici",
    premium_status: "Premium Status",
    active_premium: "Aktivni Premium Član",
    free_plan: "Besplatni plan - 10 chatova/dan",
    upgrade: "Nadogradi",
    save_settings: "Sačuvaj Postavke",
    saving: "Čuvanje...",
    delete_account: "Izbriši Račun",
    delete_permanently: "Trajno izbriši svoj račun i sve podatke",
    delete_my_account: "Izbriši Moj Račun",
    premium: "Premium",
    yublink_premium: "YuBlink Premium",
    unlimited_chats: "Neograničeni Chatovi",
    no_daily_limits: "Bez dnevnih ograničenja na nove razgovore",
    verified_badge: "Verificirana Značka",
    stand_out: "Istakni se s pouzdanim verificiranim profilom",
    priority_search: "Prioritet u Pretrazi",
    appear_first: "Pojavi se prvi u rezultatima pregledanja",
    premium_member: "Premium Član",
    exclusive_access: "Ekskluzivni pristup premium funkcijama",
    upgrade_now: "Nadogradi Sada",
    per_month: "/mjesečno",
    welcome_premium: "Dobrodošao u Premium!",
    account_upgraded: "Tvoj račun je uspješno nadograđen.",
    verifying_payment: "Provjera tvoje uplate...",
    youre_premium: "Ti si Premium!",
    enjoy_features: "Uživaj u svim premium funkcijama uključujući neograničene chatove i verificiranu značku.",
    admin_dashboard: "Administratorski Panel",
    overview: "Pregled",
    users: "Korisnici",
    reports: "Prijave",
    total_users: "Ukupno Korisnika",
    premium_users: "Premium Korisnika",
    total_chats: "Ukupno Chatova",
    total_messages: "Ukupno Poruka",
    feedback: "Povratne Informacije",
    search_users: "Pretraži po imenu ili emailu...",
    support: "Podrška",
    support_feedback: "Podrška i Povratne Informacije",
    report_bugs: "Prijavi greške ili predloži poboljšanja",
    bug_report: "Prijava Greške",
    suggestion: "Prijedlog",
    email_optional: "Email (opcionalno)",
    describe_issue: "Opiši problem ili svoj prijedlog...",
    submit_feedback: "Pošalji",
    thank_you: "Hvala!",
    feedback_submitted: "Tvoje povratne informacije su uspješno poslane.",
    go_back: "Nazad",
    impressum: "Impressum",
    datenschutz: "Zaštita Podataka (GDPR)",
    agb: "Uslovi Korištenja",
    logout: "Odjava",
    loading: "Učitavanje...",
    browse: "Pregledaj",
    profile: "Profil",
  },
  
  sr: {
    landing_tagline: "Gde se balkanska srca pronalaze",
    select_heritage: "Izaberi Svoje Poreklo",
    continue: "Nastavi",
    already_have_account: "Već imaš nalog? Prijavi se",
    country_slovenia: "Slovenija",
    country_croatia: "Hrvatska",
    country_bosnia: "Bosna i Hercegovina",
    country_serbia: "Srbija",
    country_montenegro: "Crna Gora",
    country_north_macedonia: "Severna Makedonija",
    country_kosovo: "Kosovo",
    selected_heritage: "Izabrano Poreklo",
    i_am_a: "Ja sam...",
    looking_for: "Tražim...",
    age_range: "Starosni Raspon",
    man: "Muškarac",
    woman: "Žena",
    years_old: "godina",
    back: "Nazad",
    next: "Dalje",
    get_started: "Započni",
    enter_email: "Unesi svoj email",
    verify_email: "Potvrdi svoj email",
    complete_profile: "Dovrši svoj profil",
    send_code: "Poslaćemo ti verifikacioni kod",
    enter_code: "Unesi 6-cifreni kod poslat na",
    tell_us: "Reci nam nešto o sebi",
    continue_google: "Nastavi sa Google-om",
    or_use_email: "ili koristi email",
    email_address: "Email Adresa",
    verification_code: "Verifikacioni Kod",
    send_verification: "Pošalji Verifikacioni Kod",
    verify_continue: "Potvrdi i Nastavi",
    different_email: "Koristi drugi email",
    first_name: "Ime",
    last_name: "Prezime",
    date_of_birth: "Datum Rođenja",
    current_city: "Trenutni Grad",
    about_you: "O Tebi",
    join_yublink: "Pridruži se YuBlinku",
    creating_account: "Kreiranje naloga...",
    sending: "Slanje...",
    verifying: "Provera...",
    discover: "Otkrij",
    active_now: "Aktivni Sada",
    origin_country: "Zemlja Porekla",
    all_countries: "Sve Zemlje",
    city: "Grad",
    search_city: "Pretraži po gradu...",
    verified_only: "Samo Verifikovani",
    show_verified: "Prikaz verifikovanih",
    show_all: "Prikaži sve",
    no_users: "Nema pronađenih korisnika",
    adjust_filters: "Pokušaj da prilagodiš filtere",
    blink: "Blink",
    chat: "Chat",
    about: "O Meni",
    heritage: "Poreklo",
    lives_in: "Živi u",
    photos: "Fotografije",
    message: "Poruka",
    report: "Prijavi",
    block: "Blokiraj",
    edit_profile: "Izmeni Profil",
    report_user: "Prijavi Korisnika",
    reason: "Razlog",
    submit_report: "Pošalji Prijavu",
    messages: "Poruke",
    no_conversations: "Još nema razgovora",
    start_chatting: "Započni razgovor sa stranice Pregledaj",
    select_conversation: "Izaberi razgovor",
    type_message: "Napiši poruku...",
    back_to_messages: "Nazad na poruke",
    settings: "Podešavanja",
    profile_visibility: "Vidljivost Profila",
    visible_to_others: "Tvoj profil je vidljiv drugima",
    profile_hidden: "Tvoj profil je sakriven",
    message_filter: "Filter Poruka",
    choose_who: "Izaberi ko ti može slati poruke",
    all_users: "Svi Korisnici",
    verified_users_only: "Samo Verifikovani Korisnici",
    premium_status: "Premium Status",
    active_premium: "Aktivni Premium Član",
    free_plan: "Besplatni plan - 10 chatova/dan",
    upgrade: "Nadogradi",
    save_settings: "Sačuvaj Podešavanja",
    saving: "Čuvanje...",
    delete_account: "Obriši Nalog",
    delete_permanently: "Trajno obriši svoj nalog i sve podatke",
    delete_my_account: "Obriši Moj Nalog",
    premium: "Premium",
    yublink_premium: "YuBlink Premium",
    unlimited_chats: "Neograničeni Chatovi",
    no_daily_limits: "Bez dnevnih ograničenja na nove razgovore",
    verified_badge: "Verifikovana Značka",
    stand_out: "Istakni se sa pouzdanim verifikovanim profilom",
    priority_search: "Prioritet u Pretrazi",
    appear_first: "Pojavi se prvi u rezultatima pretraživanja",
    premium_member: "Premium Član",
    exclusive_access: "Ekskluzivni pristup premium funkcijama",
    upgrade_now: "Nadogradi Sada",
    per_month: "/mesečno",
    welcome_premium: "Dobrodošao u Premium!",
    account_upgraded: "Tvoj nalog je uspešno nadograđen.",
    verifying_payment: "Provera tvoje uplate...",
    youre_premium: "Ti si Premium!",
    enjoy_features: "Uživaj u svim premium funkcijama uključujući neograničene chatove i verifikovanu značku.",
    admin_dashboard: "Administratorski Panel",
    overview: "Pregled",
    users: "Korisnici",
    reports: "Prijave",
    total_users: "Ukupno Korisnika",
    premium_users: "Premium Korisnika",
    total_chats: "Ukupno Chatova",
    total_messages: "Ukupno Poruka",
    feedback: "Povratne Informacije",
    search_users: "Pretraži po imenu ili emailu...",
    support: "Podrška",
    support_feedback: "Podrška i Povratne Informacije",
    report_bugs: "Prijavi greške ili predloži poboljšanja",
    bug_report: "Prijava Greške",
    suggestion: "Predlog",
    email_optional: "Email (opciono)",
    describe_issue: "Opiši problem ili svoj predlog...",
    submit_feedback: "Pošalji",
    thank_you: "Hvala!",
    feedback_submitted: "Tvoje povratne informacije su uspešno poslane.",
    go_back: "Nazad",
    impressum: "Impressum",
    datenschutz: "Zaštita Podataka (GDPR)",
    agb: "Uslovi Korišćenja",
    logout: "Odjava",
    loading: "Učitavanje...",
    browse: "Pregledaj",
    profile: "Profil",
  },

  sl: {
    landing_tagline: "Kjer se balkanska srca najdejo",
    select_heritage: "Izberi Svoje Poreklo",
    continue: "Nadaljuj",
    already_have_account: "Že imaš račun? Prijavi se",
    country_slovenia: "Slovenija", country_croatia: "Hrvaška", country_bosnia: "Bosna in Hercegovina",
    country_serbia: "Srbija", country_montenegro: "Črna gora", country_north_macedonia: "Severna Makedonija", country_kosovo: "Kosovo",
    selected_heritage: "Izbrano Poreklo",
    i_am_a: "Jaz sem...", looking_for: "Iščem...", age_range: "Starostni Razpon",
    man: "Moški", woman: "Ženska", years_old: "let", back: "Nazaj", next: "Naprej", get_started: "Začni",
    enter_email: "Vnesi svoj email", verify_email: "Potrdi svoj email", complete_profile: "Dopolni profil",
    send_code: "Poslali ti bomo potrditveno kodo", enter_code: "Vnesi 6-mestno kodo poslano na",
    tell_us: "Povej nam o sebi", continue_google: "Nadaljuj z Googlom", or_use_email: "ali uporabi email",
    email_address: "Email Naslov", verification_code: "Potrditvena Koda",
    send_verification: "Pošlji Potrditveno Kodo", verify_continue: "Potrdi in Nadaljuj",
    different_email: "Uporabi drug email", first_name: "Ime", last_name: "Priimek",
    date_of_birth: "Datum Rojstva", current_city: "Trenutno Mesto", about_you: "O Tebi",
    join_yublink: "Pridruži se YuBlinku", creating_account: "Ustvarjanje računa...",
    sending: "Pošiljanje...", verifying: "Preverjanje...",
    discover: "Odkrij", active_now: "Aktivni Zdaj",
    origin_country: "Država Porekla", all_countries: "Vse Države", city: "Mesto",
    search_city: "Iskanje po mestu...", verified_only: "Samo Preverjeni",
    show_verified: "Prikaz preverjenih", show_all: "Prikaži vse",
    no_users: "Ni najdenih uporabnikov", adjust_filters: "Poskusi prilagoditi filtre",
    blink: "Blink", chat: "Klepet", about: "O Meni", heritage: "Poreklo", lives_in: "Živi v",
    photos: "Fotografije", message: "Sporočilo", report: "Prijavi", block: "Blokiraj",
    edit_profile: "Uredi Profil", report_user: "Prijavi Uporabnika", reason: "Razlog",
    submit_report: "Pošlji Prijavo", messages: "Sporočila",
    no_conversations: "Še ni pogovorov", start_chatting: "Začni klepetati s strani Odkrij",
    select_conversation: "Izberi pogovor", type_message: "Napiši sporočilo...",
    back_to_messages: "Nazaj na sporočila", settings: "Nastavitve",
    profile_visibility: "Vidljivost Profila", visible_to_others: "Tvoj profil je viden drugim",
    profile_hidden: "Tvoj profil je skrit", message_filter: "Filter Sporočil",
    choose_who: "Izberi kdo ti lahko pošlje sporočila", all_users: "Vsi Uporabniki",
    verified_users_only: "Samo Preverjeni Uporabniki", premium_status: "Premium Status",
    active_premium: "Aktivni Premium Član", free_plan: "Brezplačni plan - 10 klepetov/dan",
    upgrade: "Nadgradi", save_settings: "Shrani Nastavitve", saving: "Shranjevanje...",
    delete_account: "Izbriši Račun", delete_permanently: "Trajno izbriši svoj račun in vse podatke",
    delete_my_account: "Izbriši Moj Račun", premium: "Premium", yublink_premium: "YuBlink Premium",
    unlimited_chats: "Neomejeni Klepeti", no_daily_limits: "Brez dnevnih omejitev na nove pogovore",
    verified_badge: "Preverjena Značka", stand_out: "Izstopaj s preverjanim profilom",
    priority_search: "Prednost v Iskanju", appear_first: "Pojavi se prvi v rezultatih",
    premium_member: "Premium Član", exclusive_access: "Ekskluzivni dostop do premium funkcij",
    upgrade_now: "Nadgradi Zdaj", per_month: "/mesečno",
    welcome_premium: "Dobrodošel v Premium!", account_upgraded: "Tvoj račun je uspešno nadgrajen.",
    verifying_payment: "Preverjanje tvojega plačila...", youre_premium: "Si Premium!",
    enjoy_features: "Uživaj v vseh premium funkcijah.",
    admin_dashboard: "Administratorska Plošča", overview: "Pregled", users: "Uporabniki",
    reports: "Prijave", total_users: "Skupaj Uporabnikov", premium_users: "Premium Uporabnikov",
    total_chats: "Skupaj Klepetov", total_messages: "Skupaj Sporočil", feedback: "Povratne Informacije",
    search_users: "Iskanje po imenu ali emailu...", support: "Podpora",
    support_feedback: "Podpora in Povratne Informacije", report_bugs: "Prijavi napake ali predlagaj izboljšave",
    bug_report: "Prijava Napake", suggestion: "Predlog", email_optional: "Email (neobvezno)",
    describe_issue: "Opiši težavo ali svoj predlog...", submit_feedback: "Pošlji",
    thank_you: "Hvala!", feedback_submitted: "Tvoje povratne informacije so uspešno poslane.",
    go_back: "Nazaj", impressum: "Impressum", datenschutz: "Varstvo Podatkov (GDPR)",
    agb: "Pogoji Uporabe", logout: "Odjava", loading: "Nalaganje...", browse: "Odkrij", profile: "Profil",
  },

  mk: {
    landing_tagline: "Каде балканските срца се наоѓаат",
    select_heritage: "Избери Го Своето Потекло", continue: "Продолжи",
    already_have_account: "Веќе имаш сметка? Најави се",
    country_slovenia: "Словенија", country_croatia: "Хрватска", country_bosnia: "Босна и Херцеговина",
    country_serbia: "Србија", country_montenegro: "Црна Гора", country_north_macedonia: "Северна Македонија", country_kosovo: "Косово",
    selected_heritage: "Избрано Потекло",
    i_am_a: "Јас сум...", looking_for: "Барам...", age_range: "Старосен Опсег",
    man: "Маж", woman: "Жена", years_old: "години", back: "Назад", next: "Следно", get_started: "Започни",
    enter_email: "Внеси го твојот email", verify_email: "Потврди го твојот email",
    complete_profile: "Доврши го профилот", send_code: "Ќе ти испратиме верификациски код",
    enter_code: "Внеси го 6-цифрениот код испратен на", tell_us: "Кажи ни нешто за себе",
    continue_google: "Продолжи со Google", or_use_email: "или користи email",
    email_address: "Email Адреса", verification_code: "Верификациски Код",
    send_verification: "Испрати Верификациски Код", verify_continue: "Потврди и Продолжи",
    different_email: "Користи друг email", first_name: "Име", last_name: "Презиме",
    date_of_birth: "Датум на Раѓање", current_city: "Моментален Град", about_you: "За Тебе",
    join_yublink: "Придружи се на YuBlink", creating_account: "Креирање сметка...",
    sending: "Испраќање...", verifying: "Проверување...",
    discover: "Откриј", active_now: "Активни Сега",
    origin_country: "Земја на Потекло", all_countries: "Сите Земји", city: "Град",
    search_city: "Пребарај по град...", verified_only: "Само Верифицирани",
    show_verified: "Приказ на верифицирани", show_all: "Прикажи сите",
    no_users: "Нема пронајдени корисници", adjust_filters: "Обиди се да ги прилагодиш филтрите",
    blink: "Blink", chat: "Чет", about: "За Мене", heritage: "Потекло", lives_in: "Живее во",
    photos: "Фотографии", message: "Порака", report: "Пријави", block: "Блокирај",
    edit_profile: "Измени Профил", report_user: "Пријави Корисник", reason: "Причина",
    submit_report: "Испрати Пријава", messages: "Пораки",
    no_conversations: "Сеуште нема разговори", start_chatting: "Започни разговор од страницата Откриј",
    select_conversation: "Избери разговор", type_message: "Напиши порака...",
    back_to_messages: "Назад на пораки", settings: "Поставки",
    profile_visibility: "Видливост на Профил", visible_to_others: "Твојот профил е видлив за другите",
    profile_hidden: "Твојот профил е скриен", message_filter: "Филтер за Пораки",
    choose_who: "Избери кој може да ти праќа пораки", all_users: "Сите Корисници",
    verified_users_only: "Само Верифицирани Корисници", premium_status: "Premium Статус",
    active_premium: "Активен Premium Член", free_plan: "Бесплатен план - 10 чета/ден",
    upgrade: "Надгради", save_settings: "Зачувај Поставки", saving: "Зачувување...",
    delete_account: "Избриши Сметка", delete_permanently: "Трајно избриши ја сметката и сите податоци",
    delete_my_account: "Избриши Ја Мојата Сметка", premium: "Premium", yublink_premium: "YuBlink Premium",
    unlimited_chats: "Неограничени Четови", no_daily_limits: "Без дневни ограничувања",
    verified_badge: "Верифицирана Значка", stand_out: "Истакни се со верификуван профил",
    priority_search: "Приоритет во Пребарување", appear_first: "Појави се прв во резултатите",
    premium_member: "Premium Член", exclusive_access: "Ексклузивен пристап до premium функции",
    upgrade_now: "Надгради Сега", per_month: "/месечно",
    welcome_premium: "Добредојде во Premium!", account_upgraded: "Твојата сметка е успешно надградена.",
    verifying_payment: "Проверување на уплата...", youre_premium: "Ти си Premium!",
    enjoy_features: "Уживај во сите premium функции.",
    admin_dashboard: "Админ Панел", overview: "Преглед", users: "Корисници",
    reports: "Пријави", total_users: "Вкупно Корисници", premium_users: "Premium Корисници",
    total_chats: "Вкупно Четови", total_messages: "Вкупно Пораки", feedback: "Повратни Информации",
    search_users: "Пребарај по име или email...", support: "Поддршка",
    support_feedback: "Поддршка и Повратни Информации", report_bugs: "Пријави грешки или предложи подобрувања",
    bug_report: "Пријава на Грешка", suggestion: "Предлог", email_optional: "Email (опционално)",
    describe_issue: "Опиши го проблемот или предлогот...", submit_feedback: "Испрати",
    thank_you: "Благодарам!", feedback_submitted: "Твоите повратни информации се успешно испратени.",
    go_back: "Назад", impressum: "Impressum", datenschutz: "Заштита на Податоци (GDPR)",
    agb: "Услови за Користење", logout: "Одјава", loading: "Вчитување...", browse: "Откриј", profile: "Профил",
  },

  sq: {
    landing_tagline: "Ku zemrat ballkanike gjejne njera-tjetren",
    select_heritage: "Zgjidh Trashegimne Tende", continue: "Vazhdo",
    already_have_account: "Ke tashme nje llogari? Identifikohu",
    country_slovenia: "Sllovenia", country_croatia: "Kroacia", country_bosnia: "Bosnja dhe Hercegovina",
    country_serbia: "Serbia", country_montenegro: "Mali i Zi", country_north_macedonia: "Maqedonia e Veriut", country_kosovo: "Kosova",
    selected_heritage: "Trashegimia e Zgjedhur",
    i_am_a: "Une jam...", looking_for: "Kerkoj...", age_range: "Mosha",
    man: "Burre", woman: "Grua", years_old: "vjec", back: "Mbrapa", next: "Tjeter", get_started: "Fillo",
    enter_email: "Shkruaj emailin tend", verify_email: "Verifiko emailin tend",
    complete_profile: "Ploteso profilin tend", send_code: "Do te dergojme nje kod verifikimi",
    enter_code: "Shkruaj kodin 6-shifror derguar te", tell_us: "Na trego dicka per veten",
    continue_google: "Vazhdo me Google", or_use_email: "ose perdor email",
    email_address: "Adresa Email", verification_code: "Kodi i Verifikimit",
    send_verification: "Dergo Kodin e Verifikimit", verify_continue: "Verifiko dhe Vazhdo",
    different_email: "Perdor email tjeter", first_name: "Emri", last_name: "Mbiemri",
    date_of_birth: "Data e Lindjes", current_city: "Qyteti Aktual", about_you: "Rreth Teje",
    join_yublink: "Bashkohu me YuBlink", creating_account: "Krijimi i llogarise...",
    sending: "Duke derguar...", verifying: "Duke verifikuar...",
    discover: "Zbulo", active_now: "Aktive Tani",
    origin_country: "Vendi i Origjines", all_countries: "Te Gjitha Vendet", city: "Qyteti",
    search_city: "Kerko sipas qytetit...", verified_only: "Vetem te Verifikuar",
    show_verified: "Shfaq te verifikuarit", show_all: "Shfaq te gjithe",
    no_users: "Nuk u gjeten perdorues", adjust_filters: "Provo te rregullosh filtrat",
    blink: "Blink", chat: "Bisede", about: "Rreth Meje", heritage: "Origjina", lives_in: "Jeton ne",
    photos: "Fotot", message: "Mesazh", report: "Raporto", block: "Blloko",
    edit_profile: "Ndrysho Profilin", report_user: "Raporto Perdoruesin", reason: "Arsyeja",
    submit_report: "Dergo Raportin", messages: "Mesazhet",
    no_conversations: "Ende nuk ka biseda", start_chatting: "Fillo biseden nga faqja Zbulo",
    select_conversation: "Zgjidh nje bisede", type_message: "Shkruaj mesazh...",
    back_to_messages: "Kthehu te mesazhet", settings: "Cilesimet",
    profile_visibility: "Dukshmeria e Profilit", visible_to_others: "Profili yt eshte i dukshem",
    profile_hidden: "Profili yt eshte i fshehur", message_filter: "Filtri i Mesazheve",
    choose_who: "Zgjidh kush mund te dergoje mesazhe", all_users: "Te Gjithe Perdoruesit",
    verified_users_only: "Vetem Perdorues te Verifikuar", premium_status: "Statusi Premium",
    active_premium: "Anetar Aktiv Premium", free_plan: "Plani falas - 10 biseda/dite",
    upgrade: "Perditeso", save_settings: "Ruaj Cilesimet", saving: "Duke ruajtur...",
    delete_account: "Fshi Llogarise", delete_permanently: "Fshi pergjithmone llogarise dhe te dhenat",
    delete_my_account: "Fshi Llogarise Time", premium: "Premium", yublink_premium: "YuBlink Premium",
    unlimited_chats: "Biseda Pa Kufi", no_daily_limits: "Pa kufizime ditore",
    verified_badge: "Distinktivi i Verifikuar", stand_out: "Dallou me profil te verifikuar",
    priority_search: "Prioritet ne Kerkim", appear_first: "Shfaqu i pari ne rezultate",
    premium_member: "Anetar Premium", exclusive_access: "Qasje ekskluzive ne vecori premium",
    upgrade_now: "Perditeso Tani", per_month: "/muaj",
    welcome_premium: "Mire se erdhe ne Premium!", account_upgraded: "Llogaria jote u perditesua me sukses.",
    verifying_payment: "Duke verifikuar pagesen...", youre_premium: "Je Premium!",
    enjoy_features: "Shijo te gjitha vecorite premium.",
    admin_dashboard: "Paneli i Adminit", overview: "Permbledhje", users: "Perdoruesit",
    reports: "Raportet", total_users: "Gjithsej Perdorues", premium_users: "Perdorues Premium",
    total_chats: "Gjithsej Biseda", total_messages: "Gjithsej Mesazhe", feedback: "Reagime",
    search_users: "Kerko sipas emrit ose emailit...", support: "Mbeshtetje",
    support_feedback: "Mbeshtetje dhe Reagime", report_bugs: "Raporto probleme ose sugjeroni permiresime",
    bug_report: "Raportim Problemi", suggestion: "Sugjerim", email_optional: "Email (opsionale)",
    describe_issue: "Pershkruaj problemin ose sugjerimin...", submit_feedback: "Dergo",
    thank_you: "Faleminderit!", feedback_submitted: "Reagimi yt u dergua me sukses.",
    go_back: "Kthehu", impressum: "Impressum", datenschutz: "Mbrojtja e te Dhenave (GDPR)",
    agb: "Kushtet e Perdorimit", logout: "Dil", loading: "Duke ngarkuar...", browse: "Zbulo", profile: "Profili",
  }
};

export default translations;

export const LANGUAGE_OPTIONS = [
  { code: 'en', label: 'English', flag: '🇬🇧' },
  { code: 'hr', label: 'Hrvatski', flag: '🇭🇷' },
  { code: 'bs', label: 'Bosanski', flag: '🇧🇦' },
  { code: 'sr', label: 'Srpski', flag: '🇷🇸' },
  { code: 'sl', label: 'Slovenščina', flag: '🇸🇮' },
  { code: 'mk', label: 'Македонски', flag: '🇲🇰' },
  { code: 'sq', label: 'Shqip', flag: '🇦🇱' },
];
